import styles from "./ThreeDotLoader.module.scss";
import React from "react";
import classNames from "classnames";

const ThreeDotLoader = ({ className, style}) => {
    return <div className={classNames(styles.base, className)} style={style}>
        <div className={styles.d1}/>
        <div className={styles.d2}/>
        <div className={styles.d3}/>
    </div>
};

export default ThreeDotLoader;